'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var header = function header(myMessage, compact, fontSize, badge, iconMenu, overrideStyle) {
  var style = _styles2.default.header;

  if (myMessage) {
    style = (0, _combineStyles2.default)(style, { color: _colors2.default.white });
  }

  if (iconMenu) {
    style = (0, _combineStyles2.default)(style, { marginRight: '35px' });
  }

  if (compact) {
    style = (0, _combineStyles2.default)(style, { flexShrink: '0', marginRight: '10px', marginBottom: '0' });
  }

  if (fontSize === 'medium') {
    style = (0, _combineStyles2.default)(style, { fontSize: '16px', lineHeight: '24px' });
  }

  if (fontSize === 'large') {
    style = (0, _combineStyles2.default)(style, { fontSize: '18px', lineHeight: '28px' });
  }

  if (badge) {
    style = (0, _combineStyles2.default)(style, { display: 'flex', alignItems: 'center' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var avatar = function avatar(myMessage) {
  var style = _styles2.default.avatar;

  if (myMessage) {
    style = (0, _combineStyles2.default)(style, { left: 'initial', right: '-48px', marginLeft: 0 });
  }

  return style;
};

exports.default = {
  header: header,
  avatar: avatar
};
module.exports = exports.default;